const DEFAULT_PAPER_WIDTH_MM = 72;
const MIN_PAPER_WIDTH_MM = 58;
const MAX_PAPER_WIDTH_MM = 80;
const MIN_PAGE_HEIGHT_MM = 50;
const MAX_PAGE_HEIGHT_MM = 3000;
const DEFAULT_SAFETY_MARGIN_MM = 12;
const CSS_PIXELS_PER_INCH = 96;
const MILLIMETERS_PER_INCH = 25.4;

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const normalizePaperWidthMm = (value) => {
  const numeric = Number(value);
  return clamp(
    Number.isFinite(numeric) && numeric > 0
      ? numeric
      : DEFAULT_PAPER_WIDTH_MM,
    MIN_PAPER_WIDTH_MM,
    MAX_PAPER_WIDTH_MM,
  );
};

const resolveThermalPrintableWidthMm = (value) => {
  const rollWidthMm = normalizePaperWidthMm(value);
  if (rollWidthMm <= 58) return 48;
  if (rollWidthMm >= 80) return 72;
  return rollWidthMm;
};

const calculateThermalPageSize = ({
  contentHeightPx,
  paperWidthMm = DEFAULT_PAPER_WIDTH_MM,
  safetyMarginMm = DEFAULT_SAFETY_MARGIN_MM,
  maxPageHeightMm = MAX_PAGE_HEIGHT_MM,
} = {}) => {
  const normalizedWidthMm = resolveThermalPrintableWidthMm(paperWidthMm);
  const heightPx = Math.max(1, Number(contentHeightPx) || 1);
  const marginMm = Math.max(0, Number(safetyMarginMm) || 0);
  const rawHeightMm =
    (heightPx * MILLIMETERS_PER_INCH) / CSS_PIXELS_PER_INCH + marginMm;
  const normalizedMaxHeightMm = Math.max(
    MIN_PAGE_HEIGHT_MM,
    Number(maxPageHeightMm) || MAX_PAGE_HEIGHT_MM,
  );
  const heightMm = clamp(
    Math.ceil(rawHeightMm),
    MIN_PAGE_HEIGHT_MM,
    normalizedMaxHeightMm,
  );

  return {
    widthMm: normalizedWidthMm,
    heightMm,
    pageSize: {
      width: Math.round(normalizedWidthMm * 1000),
      height: Math.round(heightMm * 1000),
    },
    wasClamped: rawHeightMm > normalizedMaxHeightMm,
  };
};

export {
  DEFAULT_PAPER_WIDTH_MM,
  MAX_PAGE_HEIGHT_MM,
  calculateThermalPageSize,
  normalizePaperWidthMm,
  resolveThermalPrintableWidthMm,
};
